import { CheckCircle2, CircleAlert } from 'lucide-react';

import type { Participante } from '@/api/secretario';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

/** A pendência que se resolve no próprio perfil leva à seção dela. */
const SECAO_DA_PENDENCIA: Record<string, string> = { sem_area: 'areas-do-advogado' };

/**
 * O advogado é oferecido ao cliente? É a mesma regra da conversa
 * (``pendencias_do_participante``): o que aparece aqui é o que o tira dela.
 */
export function ProntidaoDoAdvogado({
  participante,
  nome,
  secretarioAtivo,
}: {
  participante: Participante;
  nome: string;
  /** Desligado, ninguém é atendido: "pronto" é só "pronto para quando ligar". */
  secretarioAtivo: boolean;
}) {
  if (participante.pronto) {
    return (
      <Alert>
        <CheckCircle2 className="h-4 w-4 text-emerald-600" />
        <AlertDescription>
          {secretarioAtivo
            ? `O Secretário já oferece ${nome} aos clientes.`
            : `Pronto: o Secretário oferece ${nome} aos clientes assim que for ativado.`}
        </AlertDescription>
      </Alert>
    );
  }
  return (
    <Alert>
      <CircleAlert className="h-4 w-4 text-amber-600" />
      <AlertTitle>O Secretário ainda não oferece {nome}</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4">
          {participante.pendencias.map((p) => {
            const secao = SECAO_DA_PENDENCIA[p.chave];
            return (
              <li key={p.chave}>
                {secao ? (
                  <Button
                    type="button"
                    variant="link"
                    className="h-auto min-h-11 p-0 text-left sm:min-h-0"
                    onClick={() => {
                      const alvo = document.getElementById(secao);
                      alvo?.scrollIntoView({ behavior: 'smooth' });
                      alvo?.focus({ preventScroll: true });
                    }}
                  >
                    {p.descricao}
                  </Button>
                ) : (
                  p.descricao
                )}
              </li>
            );
          })}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
